import { render, staticRenderFns } from "./markerAdsCaro.vue?vue&type=template&id=bbdcd1a2&"
import script from "./markerAdsCaro.vue?vue&type=script&lang=js&"
export * from "./markerAdsCaro.vue?vue&type=script&lang=js&"
import style0 from "./markerAdsCaro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports